export const iconFontAwesomeMedicalHealthRadiation = (
	<i className="fa-solid fa-radiation"></i>
);
